
import { PageSection } from "@/lib/singularity/page-structure/page-structure";
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import Icon from "@/components/UI/Icon.vue";
import IconButton from "@/components/UI/IconButton.vue";
import {
  updateSectionDescription,
  updateSectionFriendlyName
} from "@/lib/singularity/page-structure/page-structure";
import { documentStore, singularityStore, uiStore } from "@/store/store";
import { aiJobController } from "@/types/singularity/ai-jobs";
import { rewriteContentInSection } from "@/lib/singularity/sections";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import NiceButton from "@/components/UI/NiceButton.vue";

@Component({
  components: {
    Icon,
    IconButton,
    TextInput,
    NiceButton
  }
})
export default class PageStructureSection extends Vue {
  @Prop()
  value!: PageSection;

  duplicateSection() {
    documentStore.duplicateElementAndActivateIt(this.value.nodeId);
  }

  deleteSection() {
    documentStore.deleteElement({ nodeId: this.value.nodeId });
  }

  updateDescription(newDescription: string) {
    updateSectionDescription(this.value.nodeId, newDescription);
  }

  updateFriendlyName(newFriendlyName: string) {
    updateSectionFriendlyName(this.value.nodeId, newFriendlyName);
  }

  rewrite() {
    aiJobController.addJob(
      async abortController => {
        await rewriteContentInSection(this.value.nodeId, abortController);
      },
      "section rewrite from PageStructureSection.vue rewrite button",
      this.value.nodeId
    );
  }

  replace() {
    singularityStore.setSectionAddOrSwapPanelState({
      mode: "swap",
      sectionIdToAddAfterOrSwap: this.value.nodeId
    });

    singularityStore.setSingularityLeftPanel("section_add_or_swap");
  }

  get classList() {
    return {
      "page-structure-section": true,
      "page-structure-section--active": this.active
    };
  }

  get active() {
    return uiStore.activeElementId === this.value.nodeId;
  }

  activateSection() {
    uiStore.activateElement(this.value.nodeId);
  }

  add() {
    alert("add");
  }

  open = false;
  toggleOpen() {
    this.open = !this.open;
  }
}
